import React, { cloneElement, useEffect, useRef, useState } from 'react';

const DESKTOP_QUERY = '(min-width: 768px)';

function FadeIn({ children }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  // Fade-in is desktop-only; on mobile the sections render as plain content.
  const [isDesktop] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(DESKTOP_QUERY).matches
  );

  useEffect(() => {
    if (!isDesktop) return;
    const node = ref.current;
    if (!node) return;

    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(node);
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [isDesktop]);

  const child = React.Children.only(children);
  if (!isDesktop) return child;

  return cloneElement(child, {
    ref,
    className: `${child.props.className || ''} fade-in-section${visible ? ' is-visible' : ''}`.trim(),
  });
}

export default FadeIn;
